<template>
  <v-container fluid class="pa-0 my-4">
    <v-row no-gutters align="center" class="title-bar">
      <v-col>
        <div class="d-flex align-center">
          <div class="title-icon mr-3">
            <v-icon size="20" color="warning">{{ icon }}</v-icon>
          </div>

          <div>
            <div class="page-title">{{ title }}</div>
            <div class="page-subtitle">{{ computedSubtitle }}</div>
          </div>
        </div>
      </v-col>
      <v-col cols="auto" class="d-flex align-center">
        <v-btn
          v-if="title && isAddBtn"
          class="add-button"
          variant="flat"
          color="#FF8A00"
          prepend-icon="mdi-plus"
          @click="$emit('add')"
        >
          {{ computedBtnText }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "RbTitleToolbar",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    btnText: {
      type: String,
      default: "",
    },
    isAddBtn: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: "mdi-view-dashboard-outline",
    },
  },

  computed: {
    computedSubtitle() {
      return ( this.subtitle ||`Manage and review all ${this.title} processed through the system.` );
    },

    computedBtnText() {
      return this.btnText || `Add ${this.title}`;
    },
  },
};
</script>

<style scoped>
.title-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(251, 181, 29, 0.1);
}
.page-title {
  color: #20242c;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}
.page-subtitle {
  margin-top: 3px;
  color: #8b929e;
  font-size: 13px;
  line-height: 1.4;
}
.add-button {
  min-height: 38px !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
}
.add-button:hover {
  transform: translateY(-1px);
}
.v-theme--dark .page-title {
  color: #f1f3f5;
}
</style>